export enum AddRecommendationMessages {
  CLOSE = 'CLOSE',
  SAVED_AS_DRAFT = 'SAVED_AS_DRAFT',
  SUCCESSFULLY_CREATED_REC = 'SUCCESSFULLY_CREATED_REC',
  SUCCESSFULLY_SHARED_REC_TO_CONVO = 'SUCCESSFULLY_SHARED_REC_TO_CONVO',
  OPEN_IMAGE_PICKER = 'OPEN_IMAGE_PICKER',
  ERROR = 'ERROR',
  MOVE_IMAGES = 'MOVE_IMAGES',
}
